import { commsStatusPageManageRoute } from '@atlassian/jira-router-routes-eoc-status-page-manage-routes/src/commsStatusPageManageRoute.tsx';
import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import {
	StatusPageManage,
	LazyStatusPageManage,
} from '@atlassian/jira-eoc-ops-status-page-manage/src/statusPageManage.tsx';

export const commsStatusPageManageRouteEntry = createEntry(commsStatusPageManageRoute, () => ({
	group: 'eoc',
	component: StatusPageManage,
	resources: [...getNavigationResources(), getConsolidationStateResource()],
	navigation: {
		menuId: MENU_ID.STATUS_PAGE_MANAGE,
		onlyShowHorizontalOnNav4: true,
	},
	forPaint: [LazyAtlassianNavigation, LazyStatusPageManage],
}));
